import { render, staticRenderFns } from "./DefaultAutocomplete.vue?vue&type=template&id=4a8d6c38&scoped=true&"
import script from "./DefaultAutocomplete.vue?vue&type=script&lang=js&"
export * from "./DefaultAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./DefaultAutocomplete.vue?vue&type=style&index=0&id=4a8d6c38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8d6c38",
  null
  
)

export default component.exports